import axios from 'axios';

const tokenRoles = sessionStorage.getItem('roles-jwt');

const headers = {
	Accept: 'application/json',
	'Content-type': 'application/json',
	'Accept-Language': 'es',
	'Cache-Control': 'no-cache',
	Pragma: 'no-cache',
	Expires: '0',
};

export const httpServices = axios.create({
	withCredentials: true,
	baseURL: import.meta.env.REACT_APP_API_ACHS,
	responseType: 'json',
	headers,
});

export const http = axios.create({
	baseURL: 'https://18d41e3c-839d-4764-b27d-0b93bfdf0cb3.mock.pstmn.io',
	responseType: 'json',
	headers,
});

export const axiosClient = (baseURL: string) => {
	const axiosCreated = axios.create({
		withCredentials: true,
		baseURL,
		headers,
	});

	// Set the AUTH token for any request
	axiosCreated.interceptors.request.use((config: any) => {
		const newConfig = config;
		const IS_SERVER = typeof window === 'undefined';
		if (!IS_SERVER) {
			const authorization = localStorage.getItem('Authorization');
			newConfig.headers.Authorization = authorization || '';
		}

		return newConfig;
	});

	return axiosCreated;
};
